import React, { useEffect, useState } from "react";
import { BASE_URL, GENERATE_ARS__INVOICE__PAYLOAD, GET_ALL_VERIFICATION_REQ, GET_ALL_VERIFIER_REQUESTS_BY_VERIFIER_ID, GET_APPEALS, GET_VERIFIER_BANNER, GLOBAL_REQUESTS, USER_TOKEN } from "../../../../Utils/constant";
import TopTitleBar from "../TopTitleBar";
import API from '../../../../ApiConfig'
import Icon from "react-icons-kit";
import { useSelector } from "react-redux";
import Loader from "../../../../components/Loader";
import Pagination from "../Pagination";
import SlideUpWrapper from "../../../../components/Transitions/SlideUpWrapper";
import { useParams } from "react-router-dom";
import cogoToast from "cogo-toast-react-17-fix";
import NavLinks from "../../../../components/NavLinks";
import useRefreshToken from "../../../../Hooks/usegenerateToken";
import Records from "../../../../components/Verifier/VerifierRequestRecords";
import { reload } from "react-icons-kit/iconic/reload";
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import AnimatedLoader from "../../../../components/AnimationLoader";
import RatePlatform from "../../../Rate Platform/RatePlatform";

import { question } from "react-icons-kit/fa"
import ReactPortalModal from "../../../../components/ReactPortalModal";
import SearchStatus from "./SearchStatus";
import PageSizeSelector from "../../../../Utils/PageSizeSelector";
export default function EmpRequest({ id }) {
    useRefreshToken(BASE_URL + USER_TOKEN)
    const [search, setSearch] = useState('')
    // const User = useSelector(state => state.User)
    const [list, setList] = useState([])
    const [apiData, setApiData] = useState([])
    const [loading, setLoading] = useState(false)
    const [currentPage, setCurrentPage] = useState(1)
    const [totalPages, setTotalPages] = useState(0)
    const [pdfLoading, setPdfLoading]=useState(false)
    const User=useSelector(state=>state.User)
    // Tabs
    const [MenuLinks, setMenuLinks] = useState([
        { name: "All Requests", link: "all", subText: '' },
        {name:"Appeals", link:"appeals", subText:""}
        // { name: "Complete", link: "DRAFT", subText: '0' },
        // { name: "Pending", link: "PUBLISHED", subText: '0' }
    ])
    const [activeTab, setActiveTab] = useState(MenuLinks[0])
    const [showBanner, setShowBanner]=useState(false)
    const [newBanner, setNewBanner]=useState("")
    const[external, setExternal]=useState("")
    
    const [transactionId, setTransactionID]=useState("")
    const [ratePlatform, setRatePlatform]=useState(false)
    const [total_items, setTotalItems]=useState(0)
    const [statusDescPopup, setStatusPopup]=useState(false)
    const[pageSize, setPageSize]=useState(10)
    function handleActiveTab(e) {
        setActiveTab(e)
        setCurrentPage(1)
    }

    useEffect(() => {
        if (activeTab.link == "") {
            setList(apiData);
        }
        else {
            let lst = apiData.filter(e => {
                return e.status == activeTab.name;
            })
            setList(lst);
        }
    }, [activeTab])

    const getInvoicePayload=()=>{
        if(transactionId==""){
            cogoToast.error("Please Enter Transactional Id")
        }
        else{
        setLoading(true)
        API.get(`${GENERATE_ARS__INVOICE__PAYLOAD}/${User.id}/${transactionId}`)
        .then(res=>{
            if(res.status==200){
                setTransactionID("")
                generatePDFs(res.data.data)
                setLoading(false)
            }
            
        })

        .catch(err=>{
            setLoading(false)
            cogoToast.error(err.response.data.message);
            
        })
    }
    }

    const generatePDFs = async (result) => {
        setPdfLoading(true)
        const config = {
            report_config: {
              report_header: "Tax Invoice",
              logo_image: "/static/images/authbridge_logo.png",
              address: {
                company_name_new: "Authbridge Research Services Pvt. Ltd.",
                company_name: "Authbridge Data Services Pvt. Ltd.",
                address1: "Plot no 123 , 2nd Floor, Udyog Vihar,",
                address2: "Phase-4 ,Gurgaon,Haryana Pin -122015",
                cin_no: "U72400HR2008PTC038552",
                website_name: "www.workattest.com",
                contact: "enquiry@workattest.com, | Contact no : 0124- 4609800"
              },
              gstin: "06AAHCA4013B1ZG",
              bank_details: "For AuthBridge Research Services Private Limited",
              beneficiary_name: "Authbridge Data Services Pvt. Ltd.",
              bank_name: "HDFC Bank Ltd.",
              bank_address: "ENKAY TOWERS,B1, VANIJYA KUNJ, PHASE V, Gurugram, HARYANA - 122001",
              account_type: "Current Account",
              account_no: "09292560000182",
              ifsc_code: "HDFC0000485",
              computer_invoice: "Computer generated Invoice and requires no signature",
              sac_code: "998314",
              payment_receipt_header: "Payment Receipt"
            }
          }


          function numberToWordsIndian(num) {
            const words = [
              '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
              'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen',
              'Seventeen', 'Eighteen', 'Nineteen', 'Twenty', 'Thirty', 'Forty', 'Fifty',
              'Sixty', 'Seventy', 'Eighty', 'Ninety'
            ];
          
            const numToWords = (n) => {
              if (n === 0) return '';
              if (n < 20) return words[n];
              if (n < 100) return words[18 + Math.floor(n / 10)] + (n % 10 ? ' ' + words[n % 10] : '');
              if (n < 1000) return words[Math.floor(n / 100)] + ' Hundred' + (n % 100 ? ' and ' + numToWords(n % 100) : '');
              if (n < 100000) return numToWords(Math.floor(n / 1000)) + ' Thousand' + (n % 1000 ? ' ' + numToWords(n % 1000) : '');
              if (n < 10000000) return numToWords(Math.floor(n / 100000)) + ' Lakh' + (n % 100000 ? ' ' + numToWords(n % 100000) : '');
              return numToWords(Math.floor(n / 10000000)) + ' Crore' + (n % 10000000 ? ' ' + numToWords(n % 10000000) : '');
            };
          
            const rupees = Math.floor(num);
            const paise = Math.round((num % 1) * 100);
          
            let result = '';
            if (rupees > 0) result += `${numToWords(rupees)} Rupees`;
            if (paise > 0) result += (result ? ' and ' : '') + `${numToWords(paise)} Paise`;
            return result ? result + ' Only' : 'Zero Rupees Only';
          }
        // for (const inv of payload) {
            // Create a hidden div for the invoice HTML
            const div = document.createElement("div");
            div.style.width = "800px";
            div.style.position = "absolute";
            div.style.left = "-9999px"
            div.style.padding="15px"
            div.innerHTML = `
             <body style="padding: 0; margin: 0;">
    <table>    
		<tr>
			<td style="padding-top: 0px; padding-bottom: 0px;">
				<!-- Centered Table Block Starts Here -->
				<table align="center" border="1" cellpadding="0" cellspacing="0" width="100%" style="border-collapse: collapse;border: 1px solid #ccc">
					<!-- Block 1 Starts Here -->
                    <tr>
                        <td width="100%" valign="middle" align="center" style="padding: 3px 0;">
                            <span style="text-transform: uppercase; font-family: arial; font-weight: bold;">${config.report_config.report_header || ''}</span>
                        </td>
                    </tr>
					<tr>
						<td style="padding: 5px;">
							<table border="0" cellspacing="0" cellpadding="0" width="100%" style="border-collapse: collapse;">
                                <tr>
									<td width="30%" valign="middle" align="left">
										<img src="/authbridge_logo.png" style="display: block; width: 250px; height: auto;" alt="">
									</td>
									<td width="70%" valign="top" align="right">
										<table border="0" cellpadding="0" cellpadding="0" style="border-collapse: collapse;margin-right: 80px;">
											<tr>
												<td align="center" style="padding: 2px 0;">
													<span style="font-family: arial; font-weight: bold;">${config.report_config.address.company_name || ''}</span>
												</td>
											</tr>
											<tr>
												<td align="center" style="padding: 2px 0;">
													<span style="font-family: arial; font-size: 15px; font-weight: bold;">
														${config.report_config.address.address1 || ''}
													</span>
												</td>
											</tr>
                                            <tr>
                                                <td align="center" style="padding: 2px 0;">
                                                    <span style="font-family: arial; font-size: 15px; font-weight: bold;">
														${config.report_config.address.address2  || ''}
													</span>
                                                </td>
                                            </tr>
											<tr>
												<td align="center" style="font-family: arial; font-size: 15px; font-weight: bold;padding: 2px 0;">
													<span>CIN: ${config.report_config.address.cin_no || ''}</span>
												</td>
											</tr>
											<tr>
												<td align="center" style="padding-bottom: 3px;">
													<span style="font-family: arial; font-size: 12px; font-weight: bold;">
														${config.report_config.address.website_name || ''}
													</span>
												</td>
											</tr>
											<tr>
												<td align="center" style="width: 300px !important;">
												  <span style="width:200px; font-family: arial; font-size: 12px; font-weight: bold;">
														${config.report_config.address.contact || ''}
													</span>
												</td>
											</tr>
										</table>
									</td>		
								</tr>
							</table>
						</td>
					</tr>
					<tr>
						<td>
							<table border="1" cellpadding="0" cellspacing="0" width="100%" style="border-collapse: collapse;" id="newTable">
									<tbody>	
										<tr>
											<th style="font-family:arial; font-weight: bold; font-size: 11px; padding: 2px;width:100px; border: 1px solid #ccc" align="left"; >GSTIN :</th>
											<td colspan="13" style="border: 1px solid #ccc">&nbsp;${config.report_config.gstin || ''}</td>
										</tr>
										<tr>
											<th style="font-family:arial; font-weight: bold; font-size: 11px; padding: 2px; border: 1px solid #ccc" align="left" >Invoice no :</th>
										    <td colspan="13" style="border: 1px solid #ccc">&nbsp;${result.invoice_no || ''}</td>
										</tr>
										<tr>
											<th style="font-family:arial; font-weight: bold; font-size: 11px; padding: 2px; border: 1px solid #ccc" align="left" >
                                                   <span class="bold_text">Invoice Date:</span>
                                            </th>
											<td colspan="13" style="border: 1px solid #ccc">
                                                 &nbsp;${result.invoice_date || ''}
                                            </td>
										</tr>
										<tr>
											<th bgcolor="#000000">&nbsp;</th>
											<th bgcolor="#000000" style="color:#ffffff; font-family:arial; font-weight: bold; font-size: 12px;" colspan="13">Details of Receiver (Billed to)</th>
										</tr>
										<tr>
											<th style="font-family:arial; font-weight: bold; font-size: 11px; padding: 2px; border: 1px solid #ccc"" align="left" >Kind Attn :</th>
											<td colspan="13" style="border: 1px solid #ccc">&nbsp;${result.search_by_name  || ''}</td>
										</tr>
										<tr>
											<th style="font-family:arial; font-weight: bold; font-size: 11px; padding: 2px; border: 1px solid #ccc" align="left" >Entity Name :</th>
											<td colspan="13" style="border: 1px solid #ccc">&nbsp;${result.verifier_name || ''}</td>
										</tr>
                                        <tr>
											<th style="font-family:arial; font-weight: bold; font-size: 11px; padding: 2px; border: 1px solid #ccc" align="left" >Address Line 1 :</th>
										        <td colspan="13" style="border: 1px solid #ccc">&nbsp;${result.address1 || ''}</td>
                                        </tr>
										<tr>
											<th style="font-family:arial; font-weight: bold; font-size: 11px; padding: 2px; border: 1px solid #ccc" align="left" >Address Line 2 :</th>
											    <td colspan="13" style="border: 1px solid #ccc">&nbsp;${result.address2 || ''}</td>
                                       </tr>
										<tr>
											<th style="font-family:arial; font-weight: bold; font-size: 11px; padding: 2px; border: 1px solid #ccc" align="left" >City :</th>
											<td colspan="13" style="border: 1px solid #ccc">&nbsp;${result.city || ''}</td>
										</tr>
										<tr>
											<th style="font-family:arial; font-weight: bold; font-size: 11px; padding: 2px; border: 1px solid #ccc" align="left" >State :</th>
											<td colspan="13" style="border: 1px solid #ccc">&nbsp;${result.state || ''}</td>
										</tr>
										<tr>
											<th style="font-family:arial; font-weight: bold; font-size: 11px; padding: 2px; border: 1px solid #ccc" align="left" >State Code :</th>
											<td colspan="13" style="border: 1px solid #ccc">&nbsp;${result.state_code || ''}</td>
										</tr>
										<tr>
											<th style="font-family:arial; font-weight: bold; font-size: 11px; padding: 2px; border: 1px solid #ccc" align="left" >Pin Code :</th>
											<td colspan="13" style="border: 1px solid #ccc">${result.pincode || ''}</td>
										</tr>
                                        <tr>
											<th style="font-family:arial; font-weight: bold; font-size: 11px; padding: 2px; border: 1px solid #ccc" align="left" >State/Place of Supply :</th>
											<td colspan="13" style="border: 1px solid #ccc">&nbsp;${result.state || ''}</td>
										</tr>
										<tr>
											<th style="font-family:arial; font-weight: bold; font-size: 11px; padding: 2px; border: 1px solid #ccc" align="left" >Country :</th>
											<td colspan="13" style="border: 1px solid #ccc">&nbsp;${'India'}</td>
										</tr>
										<tr>
											<th style="font-family:arial; font-weight: bold; font-size: 11px; padding: 2px; border: 1px solid #ccc" align="left" >GSTIN/Unique ID :</th>
											<td colspan="13" style="border: 1px solid #ccc">&nbsp;${result.verifier_gstin || ''}</td>
										</tr>
										<tr>
											<th style="font-size: 0; line-height: 0; border: 1px solid #ccc" height="18">&nbsp;</th>
											<td style="font-size: 0; line-height: 0; border: 1px solid #ccc" height="18" colspan="13" >&nbsp;</td>
										</tr>
									</tbody>
									<tbody>
									<tr>
										<th rowspan="2" style="font-family:arial; font-weight: bold; font-size: 12px; border: 1px solid #ccc" bgcolor="#cccccc" >Description of Services</th>
										<th rowspan="2" style="font-family:arial; font-weight: bold; font-size: 12px; border: 1px solid #ccc" bgcolor="#cccccc" >SAC Code</th>
										<th rowspan="2" style="font-family:arial; font-weight: bold; font-size: 12px; border: 1px solid #ccc" bgcolor="#cccccc" >No. of Cases</th>
										<th rowspan="2" style="font-family:arial; font-weight: bold; font-size: 12px; border: 1px solid #ccc" bgcolor="#cccccc" >Rate (Rs)</th>
										<th rowspan="2" style="font-family:arial; font-weight: bold; font-size: 12px; border: 1px solid #ccc" bgcolor="#cccccc" >Total (Rs)</th>
										<th rowspan="2" style="font-family:arial; font-weight: bold; font-size: 12px; border: 1px solid #ccc" bgcolor="#cccccc" >Discount (Rs)</th>
										<th rowspan="2" style="font-family:arial; font-weight: bold; font-size: 12px; border: 1px solid #ccc" bgcolor="#cccccc" >Taxable Value (Rs)</th>
										<th colspan="2" style="font-family:arial; font-weight: bold; font-size: 12px; border: 1px solid #ccc" bgcolor="#cccccc" >CGST</th>
										<th colspan="2" style="font-family:arial; font-weight: bold; font-size: 12px; border: 1px solid #ccc" bgcolor="#cccccc" >SGST/UGST</th>
										<th colspan="2" style="font-family:arial; font-weight: bold; font-size: 12px; border: 1px solid #ccc" bgcolor="#cccccc" >IGST</th>
									</tr>
									<tr>
										<th style="font-family:arial; font-weight: bold; font-size: 12px; border: 1px solid #ccc" bgcolor="#cccccc">Rate</th>
										<th style="font-family:arial; font-weight: bold; font-size: 12px; border: 1px solid #ccc" bgcolor="#cccccc">Amount (Rs)</th>
										<th style="font-family:arial; font-weight: bold; font-size: 12px; border: 1px solid #ccc" bgcolor="#cccccc">Rate</th>
										<th style="font-family:arial; font-weight: bold; font-size: 12px; border: 1px solid #ccc" bgcolor="#cccccc">Amount (Rs)</th>
										<th style="font-family:arial; font-weight: bold; font-size: 12px; border: 1px solid #ccc" bgcolor="#cccccc">Rate</th>
										<th style="font-family:arial; font-weight: bold; font-size: 12px; border: 1px solid #ccc" bgcolor="#cccccc">Amount (Rs)</th>
									</tr>
									</tbody>
									<tbody>
                                        <tr>
                                            <td style="vertical-align: middle !important; border: 1px solid #ccc" rowspan="2" align="center">Business Auxilary Services</td>
                                            <td align="center" style="border: 1px solid #ccc">${config.report_config.sac_code || ''}</td>
                                            <td align="center" style="border: 1px solid #ccc">${result.search_details.length || ''}</td>
                                            <td align="center" style="border: 1px solid #ccc">${result.search_rate || ''}</td>
                                            <td align="center" style="border: 1px solid #ccc">${result.total_invoice_value || ''}</td>
                                            <td align="center" style="border: 1px solid #ccc">${result.discount}</td>
                                            <td align="center" style="border: 1px solid #ccc">${result.taxable_value}</td>
                                            
                                            <td align="center" style="border: 1px solid #ccc">${result.cgst_percent}%</td>
                                            <td align="center" style="border: 1px solid #ccc">${result.cgst_amount}</td>
                                            <td align="center" style="border: 1px solid #ccc">${result.sgst_percent}%</td>
                                            <td align="center" style="border: 1px solid #ccc">${result.sgst_amount}</td>
                                            <td align="center" style="border: 1px solid #ccc">${result.igst_percent}%</td>
                                            <td align="center" style="border: 1px solid #ccc">${result.igst_amount}</td>
                                        </tr>
									</tbody>
									<tbody>
										<tr>
											<th style="font-family: arial; font-size: 12px; padding: 3px; border: 1px solid #ccc" colspan="2" align="left">Invoice Value in Words</th>
											<th colspan="3" align="left" style="font-family: arial; font-size: 12px; padding: 2px; border: 1px solid #ccc">Total (Rs)</th>
											<th style="border: 1px solid #ccc">${result.discount || ''}</th>
											<th style="border: 1px solid #ccc">${result.taxable_value || ''}</th>
											<th style="border: 1px solid #ccc">&nbsp;</th>
											<th style="border: 1px solid #ccc">${result.cgst_amount || ''}</th>
											<th style="border: 1px solid #ccc">&nbsp;</th>
											<th style="border: 1px solid #ccc">${result.sgst_amount || ''}</th>
											<t style="border: 1px solid #ccc"h>&nbsp;</th>
											<th style="border: 1px solid #ccc">${result.igst_amount || ''}</th>
										</tr>
										<tr>
											<td rowspan="2" colspan="2" style="border: 1px solid #ccc">${numberToWordsIndian(result.total_invoice_value) || ''}</td>
											<th colspan="3" align="left" style="font-family: arial; font-size: 12px; padding: 2px; border: 1px solid #ccc">Total Invoice Value (Rs)</th>
                                            <th colspan="8"  style="border: 1px solid #ccc">${result.total_invoice_value || ''}</th>
										</tr>
										<tr>
											<th colspan="3" align="left" style="font-family: arial; font-size: 12px; padding: 2px; border: 1px solid #ccc">Subject to reverse charge</th>
											<th colspan="8" style="border: 1px solid #ccc">&nbsp;</th>
										</tr>

										<tr>
											<th colspan="5" style="font-family: arial; font-size: 12px; padding: 3px; border: 1px solid #ccc">Bank Details:</th>
											<th colspan="8" style="font-family: arial; font-size: 12px; padding: 3px; border: 1px solid #ccc">${config.report_config.bank_details || ''}</th>
										</tr>

										<tr>
											<th align="left" style="font-family: arial; font-size: 11px; padding: 3px; border: 1px solid #ccc">Beneficiary Name: </th>
											<th colspan="4" align="left" style="font-family: arial; font-size: 11px; padding: 2px; border: 1px solid #ccc">${config.report_config.beneficiary_name || ''}</th>
											<th colspan="8" rowspan="5" style="border: 1px solid #ccc">${config.report_config.computer_invoice || ''}</th>
										</tr>
										<tr>
											<th align="left" style="font-family: arial; font-size: 11px; padding: 3px; border: 1px solid #ccc">Name of Bank : </th>
											<th colspan="4" align="left" style="font-family: arial; font-size: 11px; padding: 2px; border: 1px solid #ccc">${config.report_config.bank_name || ''}</th>
										</tr>
										<tr>
											<th align="left" style="font-family: arial; font-size: 11px; padding: 3px; border: 1px solid #ccc">Address of Bank:</th>
											<th colspan="4" align="left" style="font-family: arial; font-size: 11px; padding: 2px; border: 1px solid #ccc">${config.report_config.bank_address || ''}</th>
										</tr>
										<tr>
											<th align="left" style="font-family: arial; font-size: 11px; padding: 3px; border: 1px solid #ccc">Account Type:</th>
											<th colspan="4" align="left" style="font-family: arial; font-size: 11px; padding: 2px; border: 1px solid #ccc">${config.report_config.account_type || ''}</th>
										</tr>
										<tr>
											<th align="left" style="font-family: arial; font-size: 11px; padding: 3px; border: 1px solid #ccc">Account No.:</th>
											<th colspan="4" align="left" style="font-family: arial; font-size: 11px; padding: 2px; border: 1px solid #ccc">${config.report_config.account_no || ''}</th>
										</tr>
										<tr>
											<th align="left" style="font-family: arial; font-size: 11px; padding: 3px; border: 1px solid #ccc">IFSC / RTGS Code:</th>
											<th colspan="4" align="left" style="font-family: arial; font-size: 11px; padding: 2px; border: 1px solid #ccc">${config.report_config.ifsc_code || ''}</th>
											<th colspan="8" style="border: 1px solid #ccc"></th>
										</tr>
									</tbody>
							</table>
						</td>
					</tr>
				</table>
			</td>
		</tr>
	</table>
</body>`;


document.body.appendChild(div)
const  searchDiv=
document.createElement("div");
  searchDiv.style.width = "800px";
  searchDiv.style.position = "absolute";
  searchDiv.style.left = "-9999px";
  searchDiv.style.padding = "15px";
  searchDiv.innerHTML=
`<table style="page-break-before: always; width:98%; border-collapse: collapse; margin-top: 20px;">
  <thead>
    <tr>
      <th colspan="4" style="color: deepskyblue; font-size: 1.5em; text-align: left; padding: 3% 5%; border-bottom: 2px solid #000;">
        Search Details
      </th>
    </tr>
    <tr>
      <th style="border: 1px solid #000; padding: 5px; text-align: center;">Sr No</th>
      <th style="border: 1px solid #000; padding: 5px; text-align: left;">Contributor Name</th>
      <th style="border: 1px solid #000; padding: 5px; text-align: left;">Candidate Name</th>
      <th style="border: 1px solid #000; padding: 5px; text-align: left;">Search Key</th>
    </tr>
  </thead>
  <tbody>
    ${result.search_details.map((detail, index) => `
      <tr>
        <td style="border: 1px solid #000; padding: 5px; text-align: center;">${index + 1}</td>
        <td style="border: 1px solid #000; padding: 5px;">${detail.contributor_name || '-'}</td>
        <td style="border: 1px solid #000; padding: 5px;">${detail.candidate_name|| ''}</td>
        <td style="border: 1px solid #000; padding: 5px;">${detail.search_key || '-'}</td>
      </tr>
    `).join('')}
  </tbody>
</table>`
            
                  document.body.appendChild(searchDiv);
            
                  // Convert HTML to Canvas
                  const invoiceCanvas = await html2canvas(div, { scale: 2 });
                    const invoiceImg = invoiceCanvas.toDataURL("image/png");

                const searchCanvas = await html2canvas(searchDiv, { scale: 2 });
                    const searchImg = searchCanvas.toDataURL("image/png")
            
                  // Convert Canvas to PDF
                  const pdf = new jsPDF("p", "pt", "a4");
  const pdfWidth = pdf.internal.pageSize.getWidth();

  const invoiceProps = pdf.getImageProperties(invoiceImg);
  const invoiceHeight = (invoiceProps.height * pdfWidth) / invoiceProps.width;
                  pdf.addImage(invoiceImg, "PNG", 0, 0, pdfWidth, invoiceHeight);

                  pdf.addPage()
                  const searchProps = pdf.getImageProperties(searchImg);
  const searchHeight = (searchProps.height * pdfWidth) / searchProps.width;
  pdf.addImage(searchImg, "PNG", 0, 0, pdfWidth, searchHeight)
            
                  // Trigger download
                  pdf.save(`${result.invoice_no}-${result.transaction_id}.pdf`);
                    setPdfLoading(false)
                  document.body.removeChild(div);
                  document.body.removeChild(searchDiv)
                // }
              }
    useEffect(() => {
        const delayDebounce=setTimeout(()=>{
            getVerificationList()
      
          },500)
          return ()=>clearTimeout(delayDebounce)
    }, [currentPage, activeTab, search, pageSize])

    // useEffect(()=>{
    //   window.setTimeout( function() {
    //     window.location.reload();
    //   }, 10000)
    // },[])


    async function getVerificationList() {

        // const setmenucount = (data) => {
        //     let pending = data.filter(e => { return e.status != '1'; }).length
        //     setMenuLinks([
        //         { name: "All Requests", link: "all", subText: "" },
        //         { name: "Appeals", link: "appeals", subText:"" },
        //         // { name: "Pending on Holder", link: "PUBLISHED", subText: pending }
        //     ])
        // }

        setLoading(true)
        let apiUrl = "";
            if (activeTab.link === "all") {
                apiUrl = GLOBAL_REQUESTS;
            } else if (activeTab.link === "appeals") {
                apiUrl = `${GLOBAL_REQUESTS}?status=all_appeals`
                // GET_APPEALS;
            }
        API.get(apiUrl, {
            params: {
                page: currentPage,
                verifier_company_id:User.company_id,
                search:search,
                limit:pageSize
            }
        })
            .then(res => {
                setLoading(false)
                if (res.data.status === 200) {
                    let { data } = res.data
                    setList(data.items)
                    setApiData(data.items)
                    // setmenucount(data.items)
                    setCurrentPage(data.current_page)
                    setTotalPages(data.total_pages)
                    setExternal(data.sub_category)
                    setRatePlatform(data.ratings_submitted)
                    setTotalItems(data.total_items)
                }
            })
            .catch(err => {
                // console.log(err)
                setLoading(false)
                // cogoToast.error(err)
            })
    }
    // function handleSearch(value) {
    //     if (value.length === 0) 
    //         setList(apiData)
    //     else {
    //         let result = []
    //         {
    //             apiData.map(apiItem => {
    //                 const formUuid = Object.keys(apiItem)[0]
    //                 const formData = apiItem[formUuid];
    //                 let temp = formData.filter(item => (item.form_name.toLocaleLowerCase().includes(value.toLocaleLowerCase()) || (moment.utc(item.data_submission_date).format('DD MMM YYYY').toLocaleLowerCase().includes(value.toLocaleLowerCase()))
    //                 ))
    //                 if (temp.length > 0) result.push({ [formUuid]: temp });
    //             })
    //         }

    //         setList(result)
    //     }
    //     setSearch(value)

    // }
    const getBanner=()=>{
        API.get(GET_VERIFIER_BANNER)
        .then(res=>{
            if(res.data.data.is_active){
                setShowBanner(true)
                setNewBanner(res.data.data.message)
            }
            
        })
        .catch(err=>{

            cogoToast.error(err.response?.data?.detail)
            
        })
    }
    useEffect(()=>{
        getBanner()
    },[])
    function handleSearch(value) {
        setSearch(value)
        setCurrentPage(1)
    }

    const handlePageChange = (nextPage) => {
        setCurrentPage(nextPage);
    }
    const handleRefresh = () => {
        getVerificationList();
    }
    const handlePageSize=(newSize)=>{
        setPageSize(newSize)
        setCurrentPage(1)
      }
    return (
        <div style={{ width: "100%" }}>
         {total_items>=1 && ratePlatform==false ?  <RatePlatform isOpen={true} blockOutsideClick={true} getList={getVerificationList}/>:""}
            <SlideUpWrapper direction='slide-left'>

                <TopTitleBar isChild >
                    <h2 className="topTitleBarText"> <span className="secondaryButton1">My Requests</span></h2>
                </TopTitleBar>
                {showBanner&&
                 <div dangerouslySetInnerHTML={{ __html: newBanner }}>
                                        {/* <h2>
                                        Raise an Appeal
                                        </h2>
                                        <p style={{fontSize:"16px"}}>To raise an appeal, please send an email to authnumber-support@authbridge.com with:</p>
                                        <ul>
                                            <li style={{margin:"10px 0px"}}>The details provided by us, and</li>
                                            <li>The specific details for which you are raising the appeal, along with proper supporting documents.</li>
                                        </ul> */}
                                    </div>
                                    }
                <Loader isOpen={loading} />
                <AnimatedLoader isOpen={pdfLoading} loadingText={"Generating Invoice..."}/>
                <div className="navLinksContainer" style={{flexDirection:"row",alignItems:"center"}}>
                    <NavLinks loading={loading} MenuLinks={MenuLinks} menuClick={handleActiveTab} />
                    {/* <button className=" btn btn-primary" style={{cursor:"pointer"}}  onClick={()=>setStatusPopup(true)} title="Status Description">
                        <span>Status</span>
                        <Icon icon={question} size={12} />
                    </button> */}
                </div>
                <section className="table-header6" style={{ justifyContent: "space-between" }}>
                    <div className="inputField2">
                        <div className="input1">
                            <div className="content1">
                                <img className="searchOutlineIcon1" alt="" src="/searchoutline.svg" />
                                <input value={search} onChange={e => handleSearch(e.target.value)} className="inputText1" placeholder="Search" />
                            </div>
                        </div>
                    </div>
                    {loading?<div className="shimmer" style={{width:"10rem"}}></div>:
                        external=="" || external==="EXTERNAL"?null:
                    <div 
                        className="refreshLoader" 
                        style={{ 
                            display: "flex", 
                            alignItems: "center", 
                            justifyContent: "space-between", 
                            gap: "10px"
                        }}
                        >
                        <input 
                            type="text" 
                            className="input form-control" 
                            placeholder="Enter Transaction ID" 
                            style={{ flex: 1, marginTop:"0px", width:"100px", textAlign:"center" }}
                            onChange={(e)=>setTransactionID(e.target.value)}
                        />
                        
                        <button 
                            className="btn btn-primary" 
                            title="Reload Table" 
                            style={{ 
                            display: "flex", 
                            alignItems: "center", 
                            justifyContent: "center", 
                            whiteSpace: "nowrap" 
                            }}
                            onClick={()=>getInvoicePayload()}
                        >
                            Generate Invoice
                        </button>
                        </div>
                        } 
                </section>
                <div className="credentials-table">

                    <Records data={list} Loading={loading} requestList={getVerificationList} isExternal={external} />
                    <div style={{ margin: "10px" }}>
                    {totalPages>0&&   <PageSizeSelector value={pageSize} onChange={handlePageSize}/>}
                        <Pagination
                            nPages={totalPages}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            onPageChange={handlePageChange}
                            loading={loading}
                        />
                    </div>
                     <div style={{display:"flex",alignItems:"center",justifyContent:"center",margin:"10px 0px"}}>
                                            <ul>
                                            <li style={{fontSize:"18px", color:"red"}}>The document link is valid for 7 days only. Kindly complete the verification within this period.</li>
                                            <li style={{fontSize:"18px", color:"red"}}>An appeal can be raised within 15 days from the date of receiving the verified data.</li>
                                            </ul>
                                        </div>
                </div>
            </SlideUpWrapper>
            <ReactPortalModal isOpen={statusDescPopup} onClose={()=>setStatusPopup(false)}>
                <SearchStatus/>
            </ReactPortalModal>

        </div>
    )
}
